export default __webpack_public_path__ + "static/UFC_brasao1_horizontal_cor_72dpi-6eab13581c1d95adb618de9d2bc9d748.png";